import axios from 'axios';


const apiGatewayDataService = {
  getToken() {
    return new Promise((resolve) => {
      axios({
        method: 'post',
        url: 'https://b7pmon1keh.execute-api.us-east-1.amazonaws.com/production/getToken',
        headers: {
          'x-api-key': '5HyCgptWaR4LEZsaKEq1N46eTQOpku8O3GPZ2ld3'
        }
      }).then(response => {
        resolve(response.data);
      })
    })

  },
}

export default apiGatewayDataService